import { useEffect, useRef } from 'react';

// ============================================================
// ADSENSE SETUP INSTRUCTIONS
// ============================================================
// 1. Go to https://adsense.google.com → Get your Publisher ID
// 2. Create Ad Units → Get Slot IDs for each placement
// 3. Replace ALL "ca-pub-XXXXXXXXXXXXXXXX" with your Publisher ID
// 4. Replace each slot number below with your real Slot IDs
// 5. Also update public/index.html script tag with your Publisher ID
// ============================================================

const PUB_ID = 'ca-pub-3755460968931456'; 

// Create individual slot IDs in your AdSense dashboard for each placement
const SLOTS = {
  leaderboard:   '4362959054', // 728×90  — Apnaa Calc top of page
  mobile_banner: '9655648332', // 320×50  — Apnaa Calc mobile top
  rectangle_1:   '9464076646', // 300×250 — Apnaa Calc sidebar top
  rectangle_2:   '9691307350', // 300×250 — Apnaa Calc sidebar mid
  rectangle_3:   '6837913304', // 300×250 — Apnaa Calc sidebar bottom
  in_article_1:  '4411165710', // Apnaa Calc responsive between input & result
  in_article_2:  '2659100341', // Apnaa Calc responsive after result
  footer_banner: '7719855333', // 728×90  — Apnaa Calc above footer
  multiplex:     '5093691999', // Apnaa Calc multiplex end of page
};

function AdUnit({ slot, format = 'auto', style = {}, className = '' }) {
  const ref = useRef(null);

  useEffect(() => {
    try {
      if (window.adsbygoogle && ref.current) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (e) {}
  }, []);

  return (
    <div className={className} style={{ textAlign: 'center', ...style }}>
      <div className="ad-label">Advertisement</div>
      <ins
        className="adsbygoogle"
        ref={ref}
        style={{ display: 'block' }}
        data-ad-client={PUB_ID}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
}

// ── 1. Leaderboard — Top of every page (728×90 desktop / 320×50 mobile)
export function LeaderboardAd() {
  return (
    <div style={{ margin: '0 auto 16px', maxWidth: '728px', padding: '0 16px' }}>
      <AdUnit slot={SLOTS.leaderboard} format="auto" />
    </div>
  );
}

// ── 2. In-Article Ad — Between calculator input and results (BEST EARNER)
export function InArticleAd({ style = {} }) {
  return (
    <AdUnit
      slot={SLOTS.in_article_1}
      format="fluid"
      style={{ margin: '20px 0', ...style }}
    />
  );
}

// ── 3. Post-Result Ad — After results are shown
export function PostResultAd() {
  return (
    <AdUnit
      slot={SLOTS.in_article_2}
      format="auto"
      style={{ margin: '16px 0' }}
    />
  );
}

// ── 4. Sidebar Rectangle (300×250) — High CPM placement
export function SidebarAd({ slot = SLOTS.rectangle_1 }) {
  return (
    <div style={{ marginBottom: '16px' }}>
      <AdUnit slot={slot} format="auto" style={{ minHeight: '250px' }} />
    </div>
  );
}

// ── 5. Footer Leaderboard — Before footer
export function FooterAd() {
  return (
    <div style={{ margin: '24px auto 0', maxWidth: '728px', padding: '0 16px' }}>
      <AdUnit slot={SLOTS.footer_banner} format="auto" />
    </div>
  );
}

// ── 6. Multiplex / Related Content Ad — End of calculator page
export function MultiplexAd() {
  const ref = useRef(null);
  useEffect(() => {
    try { if (window.adsbygoogle && ref.current) { (window.adsbygoogle = window.adsbygoogle || []).push({}); } } catch(e) {}
  }, []);
  return (
    <div style={{ margin: '24px 0' }}>
      <div className="ad-label">Sponsored</div>
      <ins ref={ref} className="adsbygoogle" style={{ display: 'block' }} data-ad-client={PUB_ID} data-ad-slot={SLOTS.multiplex} data-ad-format="autorelaxed" />
    </div>
  );
}

export { SLOTS, PUB_ID };
